export default __webpack_public_path__ + "static/media/icon-20-icn-event-speed.1a3f5c82.svg";